/** Shared publishing rules for Quick Post and feed composers. */

export const CAPTION_LIMIT = 2200;
export const COMMENT_LIMIT = 500;
export const MAX_MEDIA = 10;

/** Small, deliberately conservative profanity list — blocks the obvious, avoids false positives. */
const BLOCKED = [
  "fuck", "shit", "bitch", "cunt", "asshole", "bastard", "dickhead", "motherfucker",
  "nigger", "faggot", "retard", "whore", "slut", "rape",
];

const normalise = (text: string) =>
  text
    .toLowerCase()
    .replace(/[0@]/g, "o")
    .replace(/[1!|]/g, "i")
    .replace(/\$/g, "s")
    .replace(/3/g, "e")
    .replace(/[^a-z\s]/g, " ");

/** Returns the offending words found in the text (empty when clean). */
export function findProfanity(text: string): string[] {
  const words = new Set(normalise(text).split(/\s+/).filter(Boolean));
  return BLOCKED.filter((bad) => words.has(bad));
}

export interface PostValidation {
  ok: boolean;
  error?: string;
}

/** Required fields + character limit + profanity gate before publishing. */
export function validatePost({
  caption,
  mediaCount,
  limit = CAPTION_LIMIT,
}: { caption: string; mediaCount: number; limit?: number }): PostValidation {
  const text = caption.trim();
  if (!text && mediaCount === 0) return { ok: false, error: "Add a photo, a video or write something first." };
  if (text.length > limit) return { ok: false, error: `Keep it under ${limit} characters.` };
  if (mediaCount > MAX_MEDIA) return { ok: false, error: `You can attach up to ${MAX_MEDIA} items.` };
  const bad = findProfanity(text);
  if (bad.length) return { ok: false, error: `Please remove offensive language: ${bad.join(", ")}.` };
  return { ok: true };
}
